module.exports = "Es la solicitud en línea de un Pago directo a tu aseguradora en lugar de realizar un reembolso de los productos para tu tratamiento médico."